<template>
  <v-card class="mx-auto" tile :loading="laden">
    <v-system-bar color="indigo darken-2" dark>
      <v-spacer></v-spacer>
      <span></span>
    </v-system-bar>

    <v-toolbar color="indigo" dark>
      <v-toolbar-title>Gedicht - Deel 1</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="sheet = true">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-toolbar>
    <v-layout>
      <v-container fluid>
        <br />
        <p style="margin-left: 10px;">
          2020, een jaar waarin veel is gebeurd,<br />
          Dit is alweer de laatste dag van het jaar, maar niet getreurd,<br />
          We sluiten dit jaar feestelijk af,<br />
          En dat doen we met een draf.<br />
          <br />
          Om eens bij langs te gaan,<br />
          Wat heb je dit jaar allemaal gedaan?<br />
          Een auto, een baan…<br />
          Voelt dat niet heel voldaan?<br />
          <br />
          Verder besteed je ook aandacht aan je gezin,<br />
          En dat zonder jeuk aan je kin! (Dit soort zinnen moesten er even
          in)<br />
          Af en toe een spelletje,<br />
          zoals spelen met een <i>treinstelletje</i>.<br />
          <br />
          Verder vindt je raadsels ook wel leuk,<br />
          en zo niet, lig dan maar in een deuk.<br />
          Want het antwoord op dit raadsel is al bekend,<br />
          je hoort het namelijk nog wel frequent.
        </p>
      </v-container>
    </v-layout>
    <div class="text-center">
      <v-bottom-sheet v-model="sheet" persistent>
        <v-sheet class="text-center">
          <div class="py-3">
            Een raadsel:<br />
            <b
              >“Dit verslindt al dat men kan noemen: dieren, beesten, bomen,
              bloemen. Knaagt ijzer, bijt staal, slaat hoge bergen plat en kan
              de hardste steden malen. Wat ben ik?”</b
            ><br />
            <br />
            <p class="grey--text">
              Noem het <span @click="next">antwoord</span> hardop om door te
              gaan.
            </p>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    time: "",
    laden: false,
    sheet: false,
  }),
  methods: {
    next() {
      this.$router.push({ name: "Deel2" });
    },
  },
  computed: {},
  mounted() {
    let SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    let recognition = SpeechRecognition ? new SpeechRecognition() : false;

    recognition.lang = "nl";
    recognition.interimResults = true;

    recognition.addEventListener("result", (event) => {
      const text = Array.from(event.results)
        .map((result) => result[0])
        .map((result) => result.transcript)
        .join("");
      this.time = text.split(" ").pop();
      if (text.includes("frequent")) {
        this.sheet = true;
      }
      if (text.includes("tijd") && this.sheet == true) {
        this.sheet = false;
        this.$router.push({ name: "Deel2" });
      }
    });

    recognition.addEventListener("end", () => {
      if (this.$route.name == "Deel1") {
        recognition.start();
      }
    });
    recognition.start();
  },
};
</script>
